import { routes } from "./../pages/project/routes";
import { Project } from "./../models/Project";
import { AfterViewInit, Component, OnInit } from "@angular/core";
import {
  Router,
  ActivatedRoute,
  NavigationEnd,
  Event as NavigationEvent,
} from "@angular/router";
import { filter, tap, map } from "rxjs/operators";
import { DomSanitizer } from "@angular/platform-browser";
import { Events } from "@service/events.service";
import { Profile } from "src/models/Profile";
import { select, Store } from "@ngrx/store";
import {
  MenuState,
  getAllHiddenMenuItems,
  setShowPlansButton,
  getMenuItemByTitle,
} from "@app/store";
import * as fromMenuStore from "@app/store";
import { ProjectService } from "@service/project.service";

import {
  PerfectScrollbarConfigInterface,
  PerfectScrollbarComponent,
  PerfectScrollbarDirective,
} from "ngx-perfect-scrollbar";

import { animate, style, transition, trigger } from "@angular/animations";
import { Location } from "@angular/common";

import * as Cookies from "js-cookie";
import { JoyrideSteps } from "@model/JoyrideSteps";
import { environment } from "@env/environment";
// import { SocketIo } from "@service/socket-io.service";
import { MenuItem } from "@service/app-toolbar/app-toolbar.service";
import { AuthService } from "@service/auth.service";
import { JoyrideService } from "ngx-joyride";
import { UsersService } from "@service/users.service";
import { ToastrService } from 'ngx-toastr';

declare var $: any;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  animations: [
    trigger("grow", [
      transition("void <=> *", []),
      transition(
        "* <=> *",
        [
          style({ height: "{{startHeight}}px", opacity: 0 }),
          animate(".5s ease"),
        ],
        { params: { startHeight: 0 } }
      ),
    ]),
  ],
})
export class AppComponent implements OnInit, AfterViewInit {
  public config: PerfectScrollbarConfigInterface = {};

  user: Profile;

  startHeight: number = 315;
  state = true;
  label = "TUTORIAL";

  showNavbar = false;
  showSidebar = false;
  public showFooter = true;

  currentWords: number;
  maxWords: number;

  playlistUrl: string = "PLjqmpybbUA6voLNzGfuo5bdN4394UBQpc";
  project: any;

  constructor(
    private store: Store<MenuState>,
    private authService: AuthService,
    private events: Events,
    private location: Location,
    private projectService: ProjectService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private usersService: UsersService,
    private readonly joyrideService: JoyrideService,
    // private socketIoService: SocketIo,
    private toastr: ToastrService,
  ) {
    window["base_href"] = environment.base_href;

    if (this.authService.user && this.authService.user.is_superuser) {
      this.store.dispatch(fromMenuStore.setIsSuperUser());
    }

    if (this.authService.user && this.authService.user.is_institution) {
      this.store.dispatch(fromMenuStore.setIsInstitution());
    }

    this.events.on("profile").subscribe((profile: Profile) => {
      this.user = profile;
      if (profile.is_superuser) {
        this.store.dispatch(fromMenuStore.setIsSuperUser());
      }
      if (profile.is_institution) {
        this.store.dispatch(fromMenuStore.setIsInstitution());
      }
    });

    Events.cyclePageDidMount.subscribe((url) => (this.playlistUrl = url));

    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe((e: NavigationEvent) => {
        if (e instanceof NavigationEnd) {
          const { url } = e;
          if (url === "/" || url.includes("repositories")) {
            this.store.dispatch(setShowPlansButton({ payload: true }));
            this.store.dispatch(fromMenuStore.clearMenu());
            this.store.dispatch(fromMenuStore.clearAdminUrlsMenu());
            this.addMenuItems(true);
            this.myProjectsCount();
            this.myWordsCount();
          } else if (url.includes("/project")) {
            this.store.dispatch(fromMenuStore.clearMenu());

            if (!url.includes("/document")) {
              const id = url
                .split("/")
                .map((x) => Number(x))
                .find((x) => x > 0);

              this.store.dispatch(
                fromMenuStore.addMenuItem({
                  payload: {
                    icon: "fa-clipboard-list",
                    path: `projects/${id}/planning`,
                    title: "Planejamento",
                    disable: false,
                    routerLinkActiveOptions: { exact: false },
                  },
                })
              );
              this.store.dispatch(
                fromMenuStore.addMenuItem({
                  payload: {
                    icon: "fa-laptop-code",
                    path: `projects/${id}/development`,
                    title: "Desenvolvimento",
                    disable: false,
                    routerLinkActiveOptions: { exact: false },
                  },
                })
              );
              this.store.dispatch(
                fromMenuStore.addMenuItem({
                  payload: {
                    icon: "fa-cogs",
                    path: `projects/${id}/configuration`,
                    title: "Configuração",
                    disable: false,
                    routerLinkActiveOptions: { exact: false },
                  },
                })
              );
              this.store.dispatch(
                fromMenuStore.addMenuItem({
                  payload: {
                    icon: "fa-file-alt",
                    path: `projects/${id}/document`,
                    title: "Edição de Texto",
                    disable: false,
                    routerLinkActiveOptions: { exact: false },
                  },
                })
              );
              this.store.dispatch(
                fromMenuStore.addMenuItem({
                  payload: {
                    icon: "fa-tools",
                    path: `projects/${id}/resources`,
                    title: "Recursos",
                    disable: false,
                    routerLinkActiveOptions: { exact: false },
                  },
                })
              );
              // this.store.dispatch(
              //   fromMenuStore.addMenuItem({
              //     payload: {
              //       icon: "fa-lightbulb",
              //       path: "/suggestions",
              //       title: "Sugestões",
              //       disable: false,
              //     },
              //   })
              // );
              this.store.dispatch(
                fromMenuStore.addMenuItem({
                  payload: {
                    icon: "fa-eye",
                    path: `projects/${id}/overview`,
                    title: "Visão Geral",
                    disable: false,
                    routerLinkActiveOptions: { exact: false },
                  },
                })
              );
            }
          } else if (url.includes("/admin")) {
            this.store.dispatch(fromMenuStore.clearMenu());
            this.store.dispatch(fromMenuStore.clearAdminUrlsMenu());
            this.addMenuItems(true);
            this.myProjectsCount();
            this.myWordsCount();
          } else if (url.includes("/institution")) {
            this.store.dispatch(fromMenuStore.clearMenu());
            this.store.dispatch(fromMenuStore.clearInstitutionUrlsMenu());
            this.addMenuItems(true);
            this.myProjectsCount();
            this.myWordsCount();
          }
          this.addInstitutionUrls(false);
          this.addAdminUrls(false);
          if (url !== "/") {
            this.store.dispatch(setShowPlansButton({ payload: false }));
          }
        }
      });
  }

  private addMenuItems(hide: boolean): void {
    this.store.dispatch(
      fromMenuStore.addMenuItem({
        payload: {
          icon: "fa-user-graduate",
          path: "/",
          title: "Meus Projetos",
          disable: false,
          hide,
          routerLinkActiveOptions: { exact: true },
        },
      })
    );
    this.store.dispatch(
      fromMenuStore.addMenuItem({
        payload: {
          icon: "fa-chalkboard-teacher",
          path: "/my-students",
          title: "Orientados por mim",
          disable: false,
          hide,
          routerLinkActiveOptions: { exact: false },
        },
      })
    );
    // this.store.dispatch(
    //   fromMenuStore.addMenuItem({
    //     payload: {
    //       icon: "fa-lightbulb",
    //       path: "/suggestions",
    //       title: "Sugestões",
    //       disable: false,
    //       hide,
    //     },
    //   })
    // );
    this.store.dispatch(
      fromMenuStore.addMenuItem({
        payload: {
          icon: "fa-lightbulb",
          path: "/invitations",
          title: "Convites",
          disable: false,
          hide: false,
          routerLinkActiveOptions: { exact: false },
        },
      })
    );
    this.store.dispatch(
      fromMenuStore.addMenuItem({
        payload: {
          icon: "fa-language",
          path: "/translation-page",
          title: "Tradução",
          disable: false,
          hide,
          routerLinkActiveOptions: { exact: false },
        },
      })
    );
    this.store.dispatch(
      fromMenuStore.addMenuItem({
        payload: {
          icon: "fa-book-open",
          path: "/manual-page",
          title: "Manuais e Modelos",
          disable: false,
          routerLinkActiveOptions: { exact: false },
        },
      })
    );
    this.store.dispatch(
      fromMenuStore.addMenuItem({
        payload: {
          icon: "fa-graduation-cap",
          path: "/basic-of-metodology",
          title: "Metodologia",
          disable: false,
          newMenu: true,
          routerLinkActiveOptions: { exact: false },
        },
      })
    );
    this.store.dispatch(
      fromMenuStore.addMenuItem({
        payload: {
          icon: "fa-pen",
          path: "",
          title: "Créditos",
          disable: false,
          routerLinkActiveOptions: { exact: false },
        },
      })
    );
    this.store.dispatch(
      fromMenuStore.addMenuItem({
        payload: {
          icon: "fa-pen",
          path: "/extract",
          title: "Meus Pontos",
          disable: false,
          routerLinkActiveOptions: { exact: false },
        },
      })
    );
  }

  private addAdminUrls(hide: boolean): void {
    this.store.dispatch(
      fromMenuStore.addAdminUrlMenuItem({
        payload: {
          icon: "fa-user-cog",
          path: "/admin/coupons",
          title: "Cupons",
          disable: false,
          hide,
        },
      })
    );
    // this.store.dispatch(
    //   fromMenuStore.addAdminUrlMenuItem({
    //     payload: {
    //       icon: "fa-user-cog",
    //       path: "/admin/suggestions",
    //       title: "Sugestões",
    //       disable: false,
    //       hide,
    //     },
    //   })
    // );
    // this.store.dispatch(
    //   fromMenuStore.addAdminUrlMenuItem({
    //     payload: {
    //       icon: "fa-user-cog",
    //       path: "/admin/partnerships",
    //       title: "Solicitações parceria",
    //       disable: false,
    //       hide,
    //     },
    //   })
    // );
    this.store.dispatch(
      fromMenuStore.addAdminUrlMenuItem({
        payload: {
          icon: "fa-user-cog",
          path: "/admin/institutions",
          title: "Instituições",
          disable: false,
          hide,
        },
      })
    );
    this.store.dispatch(
      fromMenuStore.addAdminUrlMenuItem({
        payload: {
          icon: "fa-user-cog",
          path: "/admin/users",
          title: "Usuários",
          disable: false,
          hide,
        },
      })
    );
    this.store.dispatch(
      fromMenuStore.addAdminUrlMenuItem({
        payload: {
          icon: "fa-user-cog",
          path: "/admin/pix-requests",
          title: "Pontos",
          disable: false,
          hide,
        },
      })
    );
  }

  private addInstitutionUrls(hide: boolean): void {
    this.store.dispatch(
      fromMenuStore.addInstitutionUrlMenuItem({
        payload: {
          icon: "fa-user-cog",
          path: "/institution",
          title: "Dashboard",
          disable: false,
          hide,
        },
      })
    );
  }

  private myProjectsCount() {
    this.projectService.myProjectsCount().subscribe((res) => {
      if (res.totalProjects > 0 || res.totalOriented > 0) {
        const menuItems$ = this.store.pipe(select(getAllHiddenMenuItems));
        menuItems$.subscribe((items: MenuItem[]) => {
          items.forEach((item) => {
            if (item.title.toLowerCase() === "meus projetos") {
              item.totalProjects = res.totalProjects;
            } else if (item.title.toLowerCase() === "orientados por mim") {
              item.totalOriented = res.totalOriented;
            }
            item.hide = false;
            this.store.dispatch(
              fromMenuStore.updateMenuItem({ payload: item })
            );
          });
        });
      }
    });
  }

  private myWordsCount() {
    this.usersService
      .getWordsCount(this.authService.user.id)
      .subscribe((res) => {
        const menuItens$ = this.store.pipe(
          select(getMenuItemByTitle("Créditos"))
        );
        menuItens$.subscribe((item: MenuItem) => {
          if (item) {
            const tokensRestantes = Math.max(0, res.max_words - res.words);
            item.title = `Créditos Mentor Virtual Restam:  ${tokensRestantes}`;
            this.store.dispatch(
              fromMenuStore.updateMenuItem({ payload: item })
            );
          }
        });
      });
  }

  ngOnInit() {
     // Aviso ao entrar na aplicação

    // this.toastr.warning('Manutenção Programada às 00:00h da Quinta-Feira 29/02/2024 ! Durante este período, nosso sistema estará temporariamente indisponível.', 'Aviso importante', {
    //   timeOut: 0, 
    //   closeButton: true 
    // });

    if (!this.location.path().includes("image-browser")) {
      this.showNavbar = this.showSidebar = true;
    }

    // this.socketIoService.connect();

    // const user = JSON.parse(localStorage.getItem("currentUser"));
    // if (user) {
    //   this.user = user;
    //   if (user.student_institution !== null) {
    //     this.socketIoService.setUserOnline({
    //       userId: user.student_institution.user_id,
    //       token: this.authService.token,
    //     });
    //   }
    // }

    this.router.events.subscribe((ar: ActivatedRoute) => {
      // if (user && user.role === 'institution' && !this.location.path().includes('/institution') &&
      //   !this.location.path().includes('/plans')) {
      //   window.location.href = `${environment.base_href}/institution`;
      // }

      if (this.location.path().includes("/editor")) {
        this.showFooter = false;
      }
    });
  }

  playlistURL() {
    return this.sanitizer.bypassSecurityTrustResourceUrl(
      `https://www.youtube.com/embed/videoseries?list=${this.playlistUrl}`
    );
  }

  toggleTutorial() {
    this.state = !this.state;

    if (!this.state) {
      this.label = "OCULTAR";

      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      this.label = "TUTORIAL";
    }
  }

  ngAfterViewInit() {
    const joyrideSteps: JoyrideSteps = JSON.parse(
      localStorage.getItem("joyrideSteps")
    );
    if (!joyrideSteps || joyrideSteps.firstStep === false) {
      this.joyrideService
        .startTour({
          steps: ["firstStep"],
          customTexts: {
            next: "Próximo",
            prev: "Anterior",
            done: "Ok",
          },
        })
        .subscribe(() => {
          localStorage.setItem(
            "joyrideSteps",
            JSON.stringify({ ...joyrideSteps, firstStep: true })
          );
        });
    }

    $(document).ready(function () {
      $("#sidebarToggleTop").css({
        "margin-left": `${$(".sidebar").width()}px`,
      });

      // Toggle the side navigation
      $("#sidebarToggle, #sidebarToggleTop").on("click", function (e) {
        $(".nav-link .badge").toggleClass("pos");
        $("body").toggleClass("sidebar-toggled");
        $(".sidebar").toggleClass("toggled");
        if ($(".sidebar").hasClass("toggled")) {
          $(".sidebar .collapse").collapse("hide");
        }
        $(this).css({ "margin-left": `${$(".sidebar").width()}px` });
        $(".annotation-card-actions").css({
          width: $(".container-annotations .card-body").width(),
        });
      });

      $(window).resize(function () {
        $("#sidebarToggleTop").css({
          "margin-left": `${$(".sidebar").width()}px`,
        });
      });
    });
  }
}
